import { DialogContent, DialogHeader } from "@/src/components/ui/dialog";
import { Dialog } from "@radix-ui/react-dialog";
import { useState } from "react";
import { Model } from "./model";
import { FactoryDialogProps } from "@/src/lib/useFactoryDialog";
import { FormControl, FormItem, FormLabel } from "@/src/components/ui/form";
import { Input } from "@/src/components/ui/input";
import { Button } from "@/src/components/ui/button";
import { useFetch } from "@/src/lib/useFetch";

export type AddModelDialogProps = FactoryDialogProps<Model>;
export function AddModelDialog(props: AddModelDialogProps) {
  const [name, setName] = useState("");
  const [manufacturer, setManufacturer] = useState("");

  const { fetch, isFetching } = useFetch();

  const createModel = () =>
    props.onDone(fetch<{ data: Model }>("/api/models/models", "POST", { name, manufacturer }).then((r) => r.data));

  return (
    <Dialog
      onOpenChange={(v) => {
        if (!v) {
          props.onDone(Promise.resolve(null));
        }
      }}
      open={props.open}
    >
      <DialogContent>
        <DialogHeader>
          <h2 className="text-3xl">Add model</h2>
        </DialogHeader>
        <FormItem required>
          <FormLabel>Model name</FormLabel>
          <FormControl>
            <Input value={name} onChange={(e) => setName(e.currentTarget.value)} />
          </FormControl>
        </FormItem>
        <FormItem required>
          <FormLabel>Manufacturer</FormLabel>
          <FormControl>
            <Input value={manufacturer} onChange={(e) => setManufacturer(e.currentTarget.value)} />
          </FormControl>
        </FormItem>
        <Button disabled={isFetching} onClick={() => createModel()}>
          Add
        </Button>
      </DialogContent>
    </Dialog>
  );
}
